import {
  Tooltip,
} from 'web-components';

import {
  icons,
  SVG,
} from 'web-styled';

import StyledIcon from './styled';

type Props = {
  id: string;
  index?: number;
  tooltip: string;
  isActive: boolean;
  isCompleted: boolean;
  onClick: { (): void };
};

const Step = ({
  id,
  index,
  tooltip,
  isActive,
  isCompleted,
  onClick,
}: Props) => {
  const renderIcon = () => {
    if (index) {
      return (
        <span>{index}</span>
      );
    }

    switch (id) {
      case 'add_client':
        return (
          <SVG.Clients stroke={isActive ? '#ffffff' : '#757575'} />
        );
      case 'send_message':
        return (
          <SVG.Messages stroke={isActive ? '#ffffff' : '#757575'} />
        );
      case 'assign_workout':
      case 'schedule_workout':
        return (
          <SVG.KettleBell stroke={isActive ? '#ffffff' : '#757575'} />
        );
      case 'add_exercise':
        return (
          <SVG.Exercise stroke={isActive ? '#ffffff' : '#757575'} />
        );
      case 'review_documents':
        return (
          <SVG.Document stroke={isActive ? '#ffffff' : '#757575'} />
        );
      case 'ideafit_perform_workout':
      case 'build_your_own_workout':
        return (
          <SVG.Program stroke={isActive ? '#ffffff' : '#757575'} />
        );
      case 'review_calendar':
        return (
          <SVG.Calendar fill={isActive ? '#ffffff' : '#757575'} />
        );
      case 'got_questions':
        return (
          <SVG.GotQuestion fill={isActive ? '#ffffff' : '#757575'} />
        );
      default:
        return (
          <SVG.Document stroke={isActive ? '#ffffff' : '#757575'} />
        );
    }
  };

  const Icon = () => (
    <StyledIcon
      isActive={isActive}
      isCompleted={isCompleted}
      onClick={onClick}
    >
      <img src={icons.check} alt="" />
      {renderIcon()}
    </StyledIcon>
  );

  if (tooltip) {
    return (
      <Tooltip
        body={tooltip}
        positions={['top']}
      >
        <div>
          <Icon />
        </div>
      </Tooltip>
    );
  }

  return (<Icon />);
};

export default Step;
